<template>
  <section>
    <div class="header">
      <div class="plan">
        <font-awesome-icon
          class="icon"
          icon="calendar-check"></font-awesome-icon>
        <span>{{detailData.plan}}</span>
      </div>
      <div class="time">
        Created<span class="time-text">{{detailData.created_at}}</span>
      </div>
      <div
        v-if="detailData.reference_no"
        class="referrence">
        Reference<span class="referrence-text">#{{detailData.reference_no}}</span>
      </div>
    </div>
    
    <div class="main">
      <div class="detail">
        <div class="detail_title">Details</div>
        <div class="table">
          <div
            v-for="(item, i) in tableList"
            :key="i"
            class="tr">
            <span>{{item.label}}</span>
            <template v-if="item.option">
              <span>{{ getOptionName(item.option, detailData[item.key]) }}</span>
            </template>
            <template v-else-if="item.arr">
              <span class="arr">
                <p
                  v-for="(subItem, sub_index) in detailData[item.key]"
                  :key="sub_index">{{subItem}}</p>
              </span>
            </template>
            <template v-else>
              <span>{{detailData[item.key]}}</span>
            </template>
          </div>
        </div>
      </div>

      <aside>
        <div class="box box-remark">
          <span class="detail_title">Remarks</span>
          <div class="remarks-container">
            <div
              v-for="(item, index) in remarkList"
              :key="index"
              class="remark-box">
              <div class="remark-header">
                <span>{{ item.cs_name }}</span>
                <span>{{ item.created_at }}</span>
              </div>
              <p>{{typeof item.message === 'object'? item.message.content: item.message  }}</p>
            </div>
          </div>
          <div class="remark-add">
            <v-input
              v-model="message"
              class="mg-b-15"
              placeholder="Add Remark"
              append="Add"
              @handlerAppend="handlerSendRemark"/>
          </div>
        </div>
      </aside>
    </div>
  </section>
</template>

<script>
import {getTalkUserDetail, talkAddRemark} from '@/api/micropolicy'
import MixinOptions from '@/mixins/options'
export default {
  name: 'ReferrerTalksDetail',
  mixins: [MixinOptions],
  data () {
    return {
      detailData: {},
      tableList: [
        {
          label: 'Title',
          key: 'isrd_title_language'
        },
        {
          label: 'Name',
          key: 'isrd_nm'
        },
        {
          label: 'Telephone No.',
          key: 'mobile_no'
        },
        {
          label: 'Email Address',
          key: 'email'
        },
        {
          label: 'Seminar Session',
          key: 'lecture_session_language'
        },
        {
          label: 'Are you a licensed insurance agent?',
          key: 'is_licensed_insurance_agent',
          option: 'yesNoOptions'
        },
        {
          label: 'Which insurer(s) are you appointed by? (If applicable)',
          key: 'com_appointed_by'
        },
        {
          label: 'How did you learn about this event?',
          key: 'learn_about_from_language',
          arr: true,
          character: '/'
        },
      ],
      message: '',
      remarkList: []
    }
  },
  computed:{
    id(){
      return this.$route.query.id
    }
  },
  watch:{
    id:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getTalkUserDetail()
        }
      }
    }
  },
  methods: {
    handlerSendRemark(){
      if(this.message){
        this.network().addRemark()
      }
    },
    network(){
      return{
        getTalkUserDetail: async () => {
          const {data} = await getTalkUserDetail({
            id: this.id
          })
          this.detailData = data
          this.remarkList = data.remark_list
        },
        addRemark: async () => {
          const {data} = await talkAddRemark({
            id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.push(data)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.header{
  padding: 0 50px;
  height: 112px;
  // background: #FAFBFC;
  box-shadow: inset 0px -1px 0px #D1D5DA;
  .plan{
    font-weight: 600;
    font-size: 16px;
    color: #24292E;
    height: 24px;
    line-height: 24px;
    display: flex;
    align-items: center;
    .icon{
      margin-right: 15px;
      color: #6A737D;
      font-size: 14px;
    }
  }
  .time, .referrence{
    margin: 8px 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    color: #586069;
    .time-text, .referrence-text{
      font-weight: 400;
      color: #24292E;
      margin-left: 8px;
    }
  }
  .referrence{
    margin: 0;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
  }
}
.main{
  margin-top: 20px;
  display: flex;
  padding: 0 50px;
  .detail_title{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
  }
  .detail{
    flex: 1;
    .table {
      margin-top: 20px;
      .tr {
        padding: 8px 16px;
        border: 1px solid #D1D5DA;
        background: #fff!important;
        display: flex;
        min-height: 36px;
        span{
          &:first-child{
            color: #586069;
            font-weight: 600;
            font-size: 14px;
          }
          &:last-child{
            color: #24292E;
            font-weight: 400;
            font-size: 14px;
          }
        }
        & + .tr{
          border-top: 0;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        .arr{
          display: flex;
          p:not(:last-child){
            &::after{
              content: "/";
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  aside {
    width: 280px;
    margin-left: 30px;
    .remarks-container {
      z-index: 1;
      max-height: 300px;
      overflow-y: auto;
      margin-top: 10px;
      .remark-box {
        margin-bottom: 10px;
        font-size: 12px;
        color: #91939a;
        .remark-header {
          display: flex;
          justify-content: space-between;
          span:first-child {
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
            color: #586069;
          }
          span:last-child{
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #6A737D;
          }
        }
        p {
          color: #24292E;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          margin: 5px 0 10px 0;
        }
      }
    }
    .remark-add {
      z-index: 2;
      margin: 0 -15px;
      padding: 15px 15px 0 15px;
    }
  }
}
</style>
